import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import styles from "./style.module.scss";
import { CardWrapper } from "../../../../components/wrapper";
import { AddSubAdminForm } from "../../../../components/parts/forms";
import { POST_API_URLS, GET_API_URLS } from "../../../../utils/constant";
import jwtInterceoptor from "../../../../api/jwtInterceptor";
import { FormErrorPopup } from "../../../../components/parts/popups";
import { Loader } from "../../../../components/ui";

const AddSubAdmin = () => {
  const [loading, setLoading] = useState(false);
  const [fetchingUser, setFetchingUser] = useState(false);
  const [error, setError] = useState(false);
  const [userData, setUserData] = useState(null);

  const location = useLocation();
  const navigate = useNavigate();
  const { userId } = useParams();

  // Fetch user data when editing (userId parameter is present)
  useEffect(() => {
    if (userId) {
      console.log("Fetching user data for ID:", userId);
      setFetchingUser(true);
      
      jwtInterceoptor
        .get(GET_API_URLS.SUB_ADMIN_URL + `${userId}/`)
        .then((response) => {
          console.log("Fetched user data:", response.data);
          setUserData({ ...response.data, password: "" }); // Clear password for security
          setFetchingUser(false);
        })
        .catch((error) => {
          console.error("Error fetching user data:", error);
          setFetchingUser(false);
          setError("Failed to fetch user data. Please try again.");
        });
    }
  }, [userId]);

  const submitDataHandler = (data) => {
    setLoading(true);
    let dataObj = {};
    for (let k in data) {
      if (k === "modules") {
        // Handle modules array - ensure it contains only IDs
        dataObj[k] = data[k].map((val) => 
          typeof val === 'object' ? val.id : parseInt(val)
        );
      } else {
        dataObj[k] = data[k];
      }
    }

    console.log("Submitting new user data:", dataObj);

    jwtInterceoptor
      .post(POST_API_URLS.ADD_SUB_ADMIN_URL, { ...dataObj, postal_code: "T4H" })
      .then((response) => {
        console.log(response);
        setLoading(false);
        navigate("/dashboard/subAdmin");
      })
      .catch((error) => {
        console.error("Error creating user:", error);
        setLoading(false);
        if(error.response?.status === 400) {
          setError(error.response.data);
        } else {
          setError(error.message);
        }
      });
  };

  const updateUserHandler = (data) => {
    console.log("Updating user data:", data);
    console.log("Current userData state:", userData);
    setLoading(true);
    let dataObj = {};
    for (let k in data) {
      if (k === "modules") {
        // Handle modules array - ensure it contains only IDs
        dataObj[k] = data[k].map((val) => 
          typeof val === 'object' ? val.id : parseInt(val)
        );
        console.log("Processing modules data:", data[k], "->", dataObj[k]);
      } else {
        dataObj[k] = data[k];
      }
    }

    console.log("Final data object to send:", dataObj);

    jwtInterceoptor
      .patch(GET_API_URLS.SUB_ADMIN_URL + `${data.id}/`, { ...dataObj })
      .then((response) => {
        console.log("User updated successfully:", response.data);
        setLoading(false);
        navigate("/dashboard/subAdmin");
      })
      .catch((error) => {
        console.error("Error updating user:", error);
        setLoading(false);
        if (error.response?.status === 403) {
          setError("You dont have permission to update this user.");
        } else {
          setError(error.message);
        }
      });
  };

  // Show loading while fetching user data
  if (fetchingUser) {
    return (
      <div className={styles.addSubAdminContainer}>
        <CardWrapper>
          <div style={{ display: 'flex', justifyContent: 'center', padding: '50px' }}>
            <Loader />
            <p style={{ marginLeft: '20px' }}>Loading user data...</p>
          </div>
        </CardWrapper>
      </div>
    );
  }

  return (
    <>
      <div className={styles.addSubAdminContainer}>
        <CardWrapper>
          <AddSubAdminForm
            updateData={updateUserHandler}
            data={submitDataHandler}
            loading={loading}
            formInitialValues={userData || (location.state ? {...location.state, password: ""} : null)}
          />
        </CardWrapper>
      </div>
      {error && <FormErrorPopup error={error} close={() => setError(false)} />}
    </>
  );
};

export default AddSubAdmin;
